export enum DBSettingsEnum {
  DB_SETTINGS_ID = 'settings',
  USER_LINK_ID = 'user_link_id',
  USER = 'user',
}

export default { DBSettingsEnum };
